import { MeasureGeometryKind } from './measure-property-types';

/** 支持触发圆弧/圆测量的几何类别集合。 */
export const MEASURE_ARC_CIRCLE_GEOMETRY_KINDS = new Set<MeasureGeometryKind>([
    MeasureGeometryKind.ArcEdge,
    MeasureGeometryKind.FullCircleEdge,
    MeasureGeometryKind.CircularSurfaceFace,
]);

/**
 * 判断测量几何类别是否属于圆弧/圆测量适用范围。
 *
 * @param geometryKind 测量几何类别。
 * @returns 是否为圆弧/圆相关几何。
 */
export function isMeasureArcCircleGeometryKind(geometryKind: MeasureGeometryKind): boolean {
    return MEASURE_ARC_CIRCLE_GEOMETRY_KINDS.has(geometryKind);
}

/**
 * 判断双选实体是否适用圆弧/圆测量策略。
 *
 * 设计说明：任一方为圆弧/整圆边/圆曲面即可启用；双方均非圆几何时不适用。
 *
 * @param geometryKindA 实体 A 几何类别。
 * @param geometryKindB 实体 B 几何类别。
 * @returns 是否适用圆弧/圆测量。
 */
export function isArcCircleMeasurementApplicable(
    geometryKindA: MeasureGeometryKind,
    geometryKindB: MeasureGeometryKind,
): boolean {
    return isMeasureArcCircleGeometryKind(geometryKindA)
        || isMeasureArcCircleGeometryKind(geometryKindB);
}
